var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useRef, useState } from 'react';
export const useGetLoginInfo = ({ onLogin, teamKey }) => {
    const isMounted = useRef(false);
    const [isLogged, setLoggedStatus] = useState(false);
    const [profilePicture, setProfilePicture] = useState('');
    const [userName, setUserName] = useState('');
    const [publicAccountId, setPublicAccountId] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        isMounted.current = true;
        const getLoginInfo = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const response = yield fetch(`https://apigw.olx.com.br/v2/me?X-OLX-TEAM-KEY=${teamKey}`, {
                    credentials: 'include',
                });
                const result = yield response.json();
                const maxUserNameLength = 16;
                const { facebookPictureUrl, googlePictureUrl, nickname, publicAccountId } = result;
                if (isMounted.current) {
                    setProfilePicture(facebookPictureUrl || googlePictureUrl || '');
                    setUserName(nickname.length < maxUserNameLength ? nickname : `${nickname.substring(0, maxUserNameLength - 1)}\u2026`);
                    setPublicAccountId(publicAccountId);
                    setLoggedStatus(true);
                }
                onLogin && onLogin();
            }
            catch (error) {
                // TODO Improvement: enviar log de erro ao Sentry
            }
            finally {
                if (isMounted.current)
                    setIsLoading(false);
            }
        });
        getLoginInfo();
        return () => {
            isMounted.current = false;
        };
    }, [onLogin, teamKey]);
    return { isLogged, profilePicture, userName, publicAccountId, isLoading };
};
